<template>
  <div class="classContainer">
    <van-nav-bar
      :title="$entryMenuName || '课程表'"
      left-text=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <div class="classSchedule">
      <div class="classTop  mb10" @click="show = true">
        <div class="classTitle clearfix">{{ majorName }}
          <img class="classSelect" src="@/assets/images/sxjt.png"/>
        </div>
        <p class="classTime">{{ semesterName }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ gradeName }}</p>
      </div>
      <div class="classTable mb10">
<!--        <div class="timeCon">-->
<!--          <p :class="[item.name == weekName?'active':'','time']" v-for="item in weekday" @click="formatList(item.name)">-->
<!--            <span class="span week">{{ item.week }}</span>-->
<!--            <span class="span">{{ item.date }}</span>-->
<!--          </p>-->
<!--        </div>-->
        <div class="changeWeek" @click.stop="showCalendar = true">
          <img src="@/assets/images/leftArrow.png" alt="" class="leftArrow">
          <span class="weekNum">{{ yearWeekDateStr }}{{mouthStr}}</span>
          <img src="@/assets/images/leftArrow.png" alt="" class="leftArrow rightArrow">
        </div>
        <el-table
          class="table"
          :data="timeTableList"
          border
          style="width: 100%"
          align="center"
          ref="table"
          stripe
        >
          <el-table-column prop="batch" align="center" min-width="40">
            <template slot="header">
              <div>课程</div>
              <div>节次</div>
            </template>
            <template slot-scope="scope">
              <div>第{{scope.row.periodNum}}节</div>
            </template>
          </el-table-column>
          <el-table-column align="center" v-for="(item,index) in weekday" width="40" :key="index+Math.random()">
            <template slot="header">
              <div>{{item.week}}</div>
              <div>{{item.date}}</div>
            </template>
            <template slot-scope="scope">
              <div v-if="scope.row[item.name].length>0" @click="checkCourse(scope.row[item.name])">{{scope.row[item.name].map(item=>item.content).join(',')}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
<!--      <div class="sectionCon">-->

<!--        <div class="section mb10" v-for="item in formatDateList" @click="goPrecess(item.planDetailId)">-->
<!--          <p class="title">第{{item.periodNum}}节</p>-->
<!--          <p class="dsc">课程：{{item.content}}</p>-->
<!--          <p class="teach">教师：{{item.teacherNames}}</p>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <van-popup v-model="show" position="bottom" round class="popupBox">
      <div class="conPopup">
        <p class="title">筛选</p>
        <div class="filtrateCon">
          <div class="filtrate">
            <p class="top">
              <span class="line"></span>
              <span class="text">专业</span>
            </p>
            <div class="itemCon">
              <p :class="[item.majorId == queryForm.majorId?'active':'','item' ]" @click="queryForm.majorId = item.majorId" v-for="item in classMajorData">{{ item.majorName }}</p>
            </div>
          </div>
          <div class="filtrate">
            <p class="top">
              <span class="line"></span>
              <span class="text">学期</span>
            </p>
            <div class="itemCon">
              <p :class="[item.semesterId == queryForm.semesterId?'active':'','item' ]" @click="queryForm.semesterId = item.semesterId" v-for="item in semesterData">{{ item.semesterName }}</p>
            </div>
          </div>
          <div class="filtrate">
            <p class="top">
              <span class="line"></span>
              <span class="text">年级</span>
            </p>
            <div class="itemCon">
              <p :class="[item.id == queryForm.classId?'active':'','item']" @click="queryForm.classId = item.id" v-for="item in classGradeData">{{ item.className }}</p>
            </div>
          </div>
<!--          <div class="filtrate">-->
<!--            <p class="top">-->
<!--              <span class="line"></span>-->
<!--              <span class="text">课时类型</span>-->
<!--            </p>-->
<!--            <div class="itemCon">-->
<!--              <p :class="[item.dictValue == queryForm.periodType?'active':'','item' ]" @click="queryForm.periodType = item.dictValue" v-for="item in periodTypeData">{{ item.dictLabel }}</p>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="btnBox">
          <div class="resetBtn" @click="resetForm">重置</div>
          <div class="completeBtn" @click="confirmSearch">确定</div>
        </div>
      </div>

    </van-popup>
    <van-calendar color="#3776FF" :min-date="minDate" :max-date="maxDate" :default-date="defaultDate" :show-toolbar="false" v-model="showCalendar" @confirm="onConfirm" />
    <van-popup v-model="showCourse" round :style="{ width: '80%' }">
      <div class="courseCon">
        <div class="courseItem" v-for="(item,index) in courseData" @click="goPrecessMain(item.planId)">{{ index+1 }}.{{ item.content }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { setToken } from '@/utils/auth'
import {
  teachingSemesterList,
  teachingMajorList,
  teachingGradeList,
  listTimetable,
  teachingPlanDetail
} from '@/api/classSchedule'
import wx from "weixin-js-sdk";
import {getDicts} from "@/api/system/dict/data";
export default {
  name: "classScheduleMain",
  data() {
    return {
      semesterName:'',
      majorName:'',
      gradeName:'',
      periodTypeName:'',
      yearWeekDateStr:'',
      mouthStr:'',
      queryForm:{
        semesterId:'',
        majorId:'',
        classId:'',
        periodType:'0',
        weekday:''
      },
      show:false,
      showCalendar: false,
      minDate:  undefined,
      maxDate: undefined,
      defaultDate:undefined,
      startTime: '',
      endTime: '',
      today: '',
      token:'',
      semesterData:[],
      classMajorData:[],
      classGradeData:[],
      weekday: [{week:'周一',date:'',name:'monday'},{week:'周二',date:'',name:'tuesday'},{week:'周三',date:'',name:'wednesday'},{week:'周四',date:'',name:'thursday'},{week:'周五',date:'',name:'friday'},{week:'周六',date:'',name:'saturday'},{week:'周日',date:'',name:'sunday'}],
      timeTableList:[],
      formatDateList:[],
      weekName:'monday',
      showCourse:false,
      courseData:[],
      // periodTypeData:[]
    }
  },
  // created() {
  //   this.token = this.$route.query.token
  //   if(this.token){
  //     setToken(this.token)
  //     this.initData();
  //   }else{
  //     this.androidIos();
  //   }
  // },
  created() {

  },
  mounted() {
    // window.getU3dParams = this.getU3dParams;
    window.addEventListener("tokenEvent",( event )=>{
      this.initData();
    }, false);
    this.initData();
  },
  methods: {
    async initData() {
      if(this.$route.query.semesterId){
        this.queryForm.semesterId = this.$route.query.semesterId
        this.queryForm.majorId = this.$route.query.majorId
        this.queryForm.classId = this.$route.query.classId
        this.semesterName = this.$route.query.semesterName
        this.majorName = this.$route.query.majorName
        // this.periodTypeName = this.$route.query.periodTypeName
        this.gradeName = this.$route.query.gradeName
        // this.queryForm.weekday = this.$route.query.weekday
        // this.yearWeekDateStr = this.$route.query.yearWeekDateStr
        // this.weekName = this.$route.query.weekName
      }
      await this.querySemesterList()
      await this.queryMajorList()
      await this.queryGradeList()
      await this.getDict()
      this.getDataClass()
    },

    //获取日历数据
    async getDataClass() {
      let res = await listTimetable(this.queryForm)
      let weeddayList = res.data.weeddayList;
      this.mouthStr = weeddayList[0].split('-')[1]+'.'+weeddayList[0].split('-')[2]+'-'+weeddayList[weeddayList.length-1].split('-')[1]+'.'+weeddayList[weeddayList.length-1].split('-')[2]
      for(var i=0;i<this.weekday.length;i++){
        this.weekday[i].date = weeddayList[i].split('-')[2]
      }
      this.timeTableList = res.data.periodVOList?res.data.periodVOList:[];
      // this.formatList(this.weekName)
    },
    getFormattedDate(){
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate
    },
    getDateToday(){
      this.today = this.getFormattedDate();
      if (new Date(this.endTime) > new Date(this.today) && new Date(this.startTime) < new Date(this.today)) {
        return true
      } else {
        return false
      }
    },
    //查询课时类型
    // getDict() {
    //   getDicts("period_type").then((res) => {
    //     this.periodTypeData = res.data;
    //     if(!this.$route.query.periodType){
    //       this.queryForm.periodType = this.periodTypeData.length > 0?this.periodTypeData[0].dictValue:'';
    //       this.periodTypeName = this.periodTypeData.length > 0?this.periodTypeData[0].dictLabel:'';
    //     }
    //   });
    // },
    //查询学期列表
    async querySemesterList() {
      let res = await teachingSemesterList()
      this.semesterData = res.data;
      let objSemester = null
      if(!this.$route.query.semesterId){
        objSemester = this.semesterData[0]
      }else{
        objSemester = this.semesterData.filter(item=>item.semesterId == this.queryForm.semesterId)[0]
      }
      if(this.semesterData.length>0){
        this.queryForm.semesterId = this.semesterData.length > 0?objSemester.semesterId:'';
        this.semesterName = this.semesterData.length > 0?objSemester.semesterName:'';
        this.startTime = objSemester.startDate
        this.endTime = objSemester.endDate
        //日历范围选择
        this.minDate = new Date(Number(this.startTime.split('-')[0]), Number(this.startTime.split('-')[1])-1, Number(this.startTime.split('-')[2]))
        this.maxDate = new Date(Number(this.endTime.split('-')[0]), Number(this.endTime.split('-')[1])-1, Number(this.endTime.split('-')[2]))
      }
      if(this.$route.query.weekday){
        this.queryForm.weekday = this.$route.query.weekday
        this.yearWeekDateStr = this.$route.query.yearWeekDateStr
        this.weekName = this.$route.query.weekName
      }else{
        if (this.getDateToday()) {
          this.queryForm.weekday = this.getFormattedDate();
        } else {
          this.queryForm.weekday = objSemester.startDate
        }
        let week = this.getYearWeek(this.queryForm.weekday.split('-')[0],this.queryForm.weekday.split('-')[1],this.queryForm.weekday.split('-')[2])
        this.yearWeekDateStr = this.queryForm.weekday.split('-')[0]+'第'+week+'周'
        this.mouthStr = this.startTime.split('-')[1]+'.'+this.startTime.split('-')[2]
        this.defaultDate = new Date(Number(this.queryForm.weekday.split('-')[0]), Number(this.queryForm.weekday.split('-')[1])-1, Number(this.queryForm.weekday.split('-')[2]))
      }

    },
    //获取专业
    async queryMajorList() {
      let res = await teachingMajorList()
      this.classMajorData = res.data;
      if(!this.$route.query.semesterId){
        this.queryForm.majorId = this.classMajorData.length > 0?this.classMajorData[0].majorId:'';
        this.majorName = this.classMajorData.length > 0?this.classMajorData[0].majorName:'';
      }

    },
    //获取年级
    async queryGradeList() {
      let res = await teachingGradeList({pageNum:1,pageSize:100})
      this.classGradeData = res.data.rows;
      if(!this.$route.query.semesterId){
        this.queryForm.classId = this.classGradeData.length > 0?this.classGradeData[0].id:'';
        this.gradeName = this.classGradeData.length > 0?this.classGradeData[0].className:'';
      }
    },
    //点击节次查看具体课程
    async checkCourse(arr){
      if(arr.length>1){
        this.courseData = arr;
        this.showCourse = true;
      }else{
        this.goPrecessMain(arr[0].planId)
      }

      // let res = await teachingPlanDetail("1955085872579477505")
    },
    onClickLeft() {
      if( localStorage.getItem("source")){
        wx.miniProgram.postMessage({
          data: {
            action:"back",
            title: 'ceshi'
          }
        })
        wx.miniProgram.navigateBack()

      }else{
        if (this.judgeClient() == "Android") {
          this.closeAndroid();
        } else {
          this.closeIos();
        }
      }


    },
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },
    closeAndroid() {
      this.$bridge.callmethod(
        "WebAction.closeWeb",
        { ceshi: "ceshi" },
        (res) => {
        }
      );
    },
    closeIos() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.closeWeb.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    //重置
    resetForm(){
      this.queryForm.semesterId = this.semesterData.length > 0?this.semesterData[0].semesterId:'';
      this.semesterName = this.semesterData.length > 0?this.semesterData[0].semesterName:'';
      this.queryForm.majorId = this.classMajorData.length > 0?this.classMajorData[0].majorId:'';
      this.majorName = this.classMajorData.length > 0?this.classMajorData[0].majorName:'';
      this.queryForm.classId = this.classGradeData.length > 0?this.classGradeData[0].id:'';
      // this.periodTypeName = this.periodTypeData.length > 0?this.periodTypeData[0].dictLabel:'';
      // this.queryForm.periodTyp = this.periodTypeData.length > 0?this.periodTypeData[0].dictValue:'';
      this.gradeName = this.classGradeData.length > 0?this.classGradeData[0].className:'';
      this.show = false
      this.getDataClass();
    },
    //确定搜索
    confirmSearch(){
      this.semesterName = this.queryForm.semesterId?this.semesterData.filter(item=>item.semesterId == this.queryForm.semesterId)[0].semesterName:'';
      this.majorName = this.queryForm.majorId?this.classMajorData.filter(item=>item.majorId == this.queryForm.majorId)[0].majorName:'';
      this.gradeName = this.queryForm.classId?this.classGradeData.filter(item=>item.id == this.queryForm.classId)[0].className:'';
      // this.periodTypeName = this.queryForm.periodType?this.periodTypeData.filter(item=>item.dictValue == this.queryForm.periodType)[0].dictLabel:'';
      this.show = false;
      let objSemester = this.semesterData.filter(item=>item.semesterId == this.queryForm.semesterId)[0]
      this.queryForm.semesterId = this.semesterData.length > 0?objSemester.semesterId:'';
      this.semesterName = this.semesterData.length > 0?objSemester.semesterName:'';
      this.startTime = objSemester.startDate
      this.endTime = objSemester.endDate
      //日历范围选择
      this.minDate = new Date(Number(this.startTime.split('-')[0]), Number(this.startTime.split('-')[1])-1, Number(this.startTime.split('-')[2]))
      this.maxDate = new Date(Number(this.endTime.split('-')[0]), Number(this.endTime.split('-')[1])-1, Number(this.endTime.split('-')[2]))
      if(this.$route.query.weekday){
        this.queryForm.weekday = this.$route.query.weekday
        this.yearWeekDateStr = this.$route.query.yearWeekDateStr
        this.weekName = this.$route.query.weekName
      }else{
        if (this.getDateToday()) {
          this.queryForm.weekday = this.getFormattedDate();
        } else {
          this.queryForm.weekday = objSemester.startDate
        }
        let week = this.getYearWeek(this.queryForm.weekday.split('-')[0],this.queryForm.weekday.split('-')[1],this.queryForm.weekday.split('-')[2])
        this.yearWeekDateStr = this.queryForm.weekday.split('-')[0]+'第'+week+'周'
        this.mouthStr = this.startTime.split('-')[1]+'.'+this.startTime.split('-')[2]
        this.defaultDate = new Date(Number(this.queryForm.weekday.split('-')[0]), Number(this.queryForm.weekday.split('-')[1])-1, Number(this.queryForm.weekday.split('-')[2]))
      }
      this.getDataClass();
    },
    //跳转课表进度表
    goPrecessMain(planId){
      this.$router.push('/teachProcessMain?planId='+planId
        +'&semesterId='+this.queryForm.semesterId
        +'&majorId='+this.queryForm.majorId
        +'&classId='+this.queryForm.classId
        +'&weekday='+this.queryForm.weekday
        +'&semesterName='+this.semesterName
        +'&majorName='+this.majorName
        +'&gradeName='+this.gradeName
        +'&yearWeekDateStr='+this.yearWeekDateStr
        +'&weekName='+this.weekName
      )
    },
    //选择日期
    onConfirm(date){
      let getMonth='',getDay='';
      if (date.getMonth()+1<10){
        getMonth = '0'+(date.getMonth()+1)
      }else{
        getMonth = (date.getMonth()+1)
      }
      if (date.getDate()<10){
        getDay = '0'+(date.getDate())
      }else{
        getDay = date.getDate()
      }
      this.queryForm.weekday = date.getFullYear()+'-'+getMonth+'-'+getDay
      let week = this.getYearWeek(date.getFullYear(),getMonth,getDay)
      this.yearWeekDateStr = date.getFullYear()+'第'+week+'周'
      this.showCalendar = false;
      this.getDataClass()
    },
    //根据日期获取年周
    getYearWeek(a, b, c){
      var date1 = new Date(a, parseInt(b) - 1, c),  //当前日期
        date2 = new Date(a, 0, 1),  //当年第一天
        // d是当前日期是今年第多少天
        d = Math.round((date1.valueOf() - date2.valueOf()) / 86400000);
      // d + 当前年的第一天的周差距的和在除以7就是本年第几周
      return Math.ceil((d + (date2.getDay() + 1 - 1)) / 7);
    },
    // formatList(type){
    //   this.weekName = type
    //   this.formatDateList = this.timeTableList[type]
    // },
  },
}
</script>
<style scoped lang="scss">
::v-deep .van-nav-bar .van-icon{
  color: #2F2F46
}
.mb10{
  margin-bottom: 10px;
}
.classContainer{
  .classSchedule{
    min-height: calc(100vh - 46px);
    background: #f5f5f5;
    padding: 8px 12px;
    .classTop{
      padding: 14px 17px;
      background: #FFFFFF;
      border-radius: 10px;
      .classTitle{
        font-weight: 600;
        font-size: 16px;
        color: #2F2F46;
        .classSelect{
          width: 6px;
          height: 11px;
          margin-left: 7px;
        }

      }
      .classTime{
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #8F91A1;
      }
    }
    .classTable{
      padding: 10px 12px 12px 17px;
      background: #FFFFFF;
      border-radius: 10px;
      .timeCon{
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        color: #2F2F46;
        .time{
          width: 36px;
          height: 50px;
          padding: 8px 0;
          text-align: center;
          .span{
            display: block;
          }
          .week{
            margin-bottom: 6px;
          }
        }
        .active{
          color: #FFFFFF;
          background: #3776FF;
          border-radius: 8px;
        }
      }
    }
    .changeWeek{
      margin-bottom: 10px;
      display: flex;
      justify-content: right;
      .leftArrow{
        width: 14px;
      }
      .weekNum{
        font-weight: 400;
        font-size: 11px;
        color: #8F91A1;
        margin: 0;
        letter-spacing:1px
      }
      .rightArrow{
        transform: rotate(180deg);
      }
    }
    .sectionCon{
      height: calc(100% - 200px);
      overflow-y: auto;


      .section{
        padding: 14px 17px 9px 17px;
        background: #FFFFFF;
        border-radius: 10px;
        .title{
          font-weight: 600;
          font-size: 14px;
          color: #2F2F46;
        }
        .dsc,.teach{
          margin-top: 5px;
          font-weight: 400;
          font-size: 14px;
          color: #7A7C8B;
        }
      }
      .section:last-child{
        margin-bottom: 0;
      }
    }

  }
}
.conPopup{
  padding: 16px;
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    color: #2F2F46;
  }
  .filtrateCon{
    margin-top: 10px;
    max-height: 500px;
    overflow-y: auto;
    .filtrate{
      margin-bottom: 18px;
      .top{
        display: flex;
        align-items: center;
        .line{
          display: inline-block;
          width: 3px;
          height: 16px;
          background: #378CFF;
          border-radius: 1px;
        }
        .text{
          margin-left: 6px;
          font-weight: 600;
          font-size: 16px;
          color: #2F2F46;
        }
      }
      .itemCon{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item{
          margin-top: 14px;
          width: calc(50% - 16px);
          height: 40px;
          text-align: center;
          line-height: 40px;
          background: #FFFFFF;
          border-radius: 8px;
          border: 1px solid #EEEEEE;
          font-weight: 400;
          font-size: 15px;
          color: #2F2F46;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .active{
          background: #EBF1FF;
          color: #3776FF;
          border:none;
        }
        .item4{
          width: calc(25% - 16px);
          margin-right: 16px;
        }
      }
      .itemCon4{
        justify-content: start;
      }
    }
  }
  .btnBox {
    display: flex;
    margin-top: 59px;
    width: 100%;
    height: 44px;
    .resetBtn {
      width: 50%;
      height: 44px;
      background: #EBF1FF;
      border-radius: 22px 0px 0px 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #3776FF;
      line-height: 44px;
      text-align: center;
      font-style: normal;
    }
    .completeBtn {
      width: 50%;
      height: 44px;
      background: #3776FF;
      border-radius: 0px 22px 22px 0px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      font-style: normal;
    }
  }
}
.courseCon{
  padding: 16px;
  .courseItem{
    font-size: 16px;
    color: #3776FF;
    margin-bottom: 10px;
  }
}
::v-deep .el-table .cell{
  padding: 10px 0!important;
}
::v-deep .el-table tbody .cell{
  height: 80px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
</style>
